// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import {UrlSearch} from "./assets/js/utils";
let Request =new UrlSearch()
Vue.prototype.$Request=Request
Vue.config.productionTip = false
import Vant from 'vant';
import 'vant/lib/index.css';
Vue.use(Vant);
Vue.prototype.$axios = axios
// axios.defaults.baseURL = 'http://www.zhishou.com/index.php/api/'; // 填写后台请求统一的地址
axios.defaults.baseURL = 'http://monitor.summit.com.cn/index.php/api/'; // 填写后台请求统一的地址





/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js